import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6fe66e9f"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "main_area" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "古いデータ", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "-------------------------------------", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "新しいデータ", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "下記の内容で登録します。よろしいですか？", -1))
const _hoisted_6 = { class: "container1" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "koumokuLeft" }, [
  /*#__PURE__*/_createElementVNode("p", null, "企画ID"),
  /*#__PURE__*/_createElementVNode("p", null, "タイトル"),
  /*#__PURE__*/_createElementVNode("p", null, "タイトル（カナ）")
], -1))
const _hoisted_8 = { class: "koumokuRight" }
const _hoisted_9 = {
  key: 0,
  class: "container2"
}
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "企画基本情報", -1))
const _hoisted_11 = { class: "frame_table" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", { class: "common_th koumokuMei" }, "項目名"),
    /*#__PURE__*/_createElementVNode("th", { class: "common_th tourokuZumi" }, "登録済内容"),
    /*#__PURE__*/_createElementVNode("th", { class: "common_th nyuryoku" }, "入力内容")
  ])
], -1))
const _hoisted_13 = { class: "nyuryokuNaiyou" }
const _hoisted_14 = {
  key: 1,
  class: "container3"
}
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "仮仕様情報", -1))
const _hoisted_16 = { class: "frame_table" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", { class: "common_th koumokuMei" }, "項目名"),
    /*#__PURE__*/_createElementVNode("th", { class: "common_th tourokuZumi" }, "登録済内容"),
    /*#__PURE__*/_createElementVNode("th", { class: "common_th nyuryoku" }, "入力内容")
  ])
], -1))
const _hoisted_18 = { class: "nyuryokuNaiyou" }
const _hoisted_19 = { class: "buttonContainer" }

import { Ref, computed, onMounted, ref, watch, watchEffect } from "vue";
import { useRoute, useRouter } from "vue-router";
import { useStore } from "vuex";

interface ComparisonResult {
  key: string;
  oldValue: any;
  newValue: any;
  item: string;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'KikakuSubmit',
  setup(__props) {

const router = useRouter();
const store = useStore();
const route = useRoute();

const oldDataKikaku = ref();
const newDataKikaku = ref();
const oldDataSiyo = ref();
const newDataSiyo = ref();
const hikakuList = ref<ComparisonResult[]>([]);
const SiyohikakuList = ref<ComparisonResult[]>([]);
const oldKikakuDataList: any[] = [];

const kikakuData = ref();
watchEffect(() => {
  kikakuData.value = route.params.kikakuData;
  oldDataKikaku.value = store.state.kikakuold.oldKikakuData;
  newDataKikaku.value = store.state.kikakunew.newKikakuData.kikaku;
  oldDataSiyo.value = store.state.kikakuold.oldKikakuData.kariSiyo;
  newDataSiyo.value = store.state.kikakunew.newKikakuData.kariSiyo;
});

onMounted(() => {

  function compareSpecifiedKeys(oldDataKikaku: any, newDataKikaku: any) {
    const keyMappings = [
      {
        key: "kikakuMei",
        oldPath: (data: { kikakuMei: any }) => data?.kikakuMei,
        newPath: (data: { kikakuMei: any }) => data?.kikakuMei,
        item: "タイトル",
      },
      {
        key: "kikakuMeiKana",
        oldPath: (data: { kikakuMeiKana: any }) => data?.kikakuMeiKana,
        newPath: (data: { kikakuMeiKana: any }) => data?.kikakuMeiKana,
        item: "タイトル（カナ）",
      },
      {
        key: "syohinKbnId",
        oldPath: (data: { syohinKbnId: any }) => data?.syohinKbnId,
        newPath: (data: { syohinKbnId: any }) => data?.syohinKbnId,
        item: "商品区分",
      },
      {
        key: "syohinBunruiId",
        oldPath: (data: { syohinBunruiId: any }) => data?.syohinBunruiId,
        newPath: (data: { syohinBunruiId: any }) => data?.syohinBunruiId,
        item: "商品分類",
      },
      {
        key: "hannyuKiboYearAndMonth",
        oldPath: (data: { hannyuKiboYearAndMonth: any }) =>
          data?.hannyuKiboYearAndMonth,
        newPath: (data: { hannyuKiboYearAndMonth: any }) =>
          data?.hannyuKiboYearAndMonth,
        item: "搬入希望月",
      },
      {
        key: "isCancel",
        oldPath: (data: { isCancel: any }) => data?.isCancel,
        newPath: (data: { isCancel: any }) => data?.isCancel,
        item: "企画中止",
      },
      {
        key: "hannyuKiboYearAndMonth",
        oldPath: (data: { cancelRiyu: any }) => data?.cancelRiyu,
        newPath: (data: { cancelRiyu: any }) => data?.cancelRiyu,
        item: "企画中止理由",
      },
    ];

    const changes: {
      key: string;
      oldValue: any;
      newValue: any;
      item: string;
    }[] = [];

    keyMappings.forEach(({ key, oldPath, newPath, item }) => {
      const oldValue = oldPath(oldDataKikaku);
      const newValue = newPath(newDataKikaku);
      if (oldValue !== newValue) {
        changes.push({ key, oldValue, newValue, item });
      }
    });

    return changes;
  }
  function compareSpecifiedSiyoKeys(oldDataSiyo: any, newDataSiyo: any) {
    const keyMappings = [
      {
        key: "seihonSiyoId",
        oldPath: (data: { seihonSiyoId: any }) => data?.seihonSiyoId,
        newPath: (data: { seihonSiyoId: any }) => data?.seihonSiyoId,
        item: "製本",
      },
      {
        key: "hangataId",
        oldPath: (data: { hangataId: any }) => data?.hangataId,
        newPath: (data: { hangataId: any }) => data?.hangataId,
        item: "判型",
      },
      {
        key: "singleColorQty",
        oldPath: (data: { singleColorPageQty: any }) =>
          data?.singleColorPageQty,
        newPath: (data: { singleColorQty: any }) => data?.singleColorQty,
        item: "1Cページ数",
      },
      {
        key: "fullColorQty",
        oldPath: (data: { fullColorPageQty: any }) => data?.fullColorPageQty,
        newPath: (data: { fullColorQty: any }) => data?.fullColorQty,
        item: "4Cページ数",
      },
      {
        key: "weight",
        oldPath: (data: { weight: any }) => data?.weight,
        newPath: (data: { weight: any }) => data?.weight,
        item: "重量",
      },
    ];

    const changes: {
      key: string;
      oldValue: any;
      newValue: any;
      item: string;
    }[] = [];

    keyMappings.forEach(({ key, oldPath, newPath, item }) => {
      const oldValue = oldPath(oldDataSiyo);
      const newValue = newPath(newDataSiyo);
      if (oldValue !== newValue) {
        changes.push({ key, oldValue, newValue, item });
      }
    });

    return changes;
  }

  const hikakus = compareSpecifiedKeys(
    oldDataKikaku.value,
    newDataKikaku.value
  );
  hikakuList.value = hikakus;
  // console.log("企画のひかく", hikakuList); // 修正されたログ出力

  const Siyohikakus = compareSpecifiedSiyoKeys(
    oldDataSiyo.value,
    newDataSiyo.value
  );
  SiyohikakuList.value = Siyohikakus;
  // console.log("仕様のひかく", SiyohikakuList); // 修正されたログ出力
});


const backtokikakuedit = (kikakuId: number | undefined) => {
  // 新規登録の場合
  if (kikakuId === undefined) {
    router.push({
      path: "kikaku_new",
      query: {
        fromConfirm: "true",
      },
    });
    // 編集の場合
  } else {
    router.push({
      path: "/kikaku_edit",
      query: { kikakuId: kikakuId, fromConfirm: "true" },
    });
  }
};

const submitData = () => {
  // store.commit("createKikaku",)
  store.dispatch("submitKikakuData"); //action
  // store.commit("createKikakuClear");
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", null, [
      _hoisted_2,
      _createElementVNode("div", null, _toDisplayString(oldDataKikaku.value), 1),
      _hoisted_3,
      _hoisted_4,
      _createElementVNode("div", null, _toDisplayString(newDataKikaku.value), 1),
      _hoisted_5,
      _createElementVNode("div", _hoisted_6, [
        _hoisted_7,
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("p", null, ": " + _toDisplayString(newDataKikaku.value.kikakuId), 1),
          _createElementVNode("p", null, ": " + _toDisplayString(newDataKikaku.value.kikakuMei), 1),
          _createElementVNode("p", null, ": " + _toDisplayString(newDataKikaku.value.kikakuMeiKana), 1)
        ])
      ])
    ]),
    (hikakuList.value.length > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
          _hoisted_10,
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("table", null, [
              _hoisted_12,
              _createElementVNode("tbody", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(hikakuList.value, (hikaku) => {
                  return (_openBlock(), _createElementBlock("tr", {
                    key: hikaku.key
                  }, [
                    _createElementVNode("td", null, _toDisplayString(hikaku.item), 1),
                    _createElementVNode("td", null, _toDisplayString(hikaku.oldValue), 1),
                    _createElementVNode("td", _hoisted_13, _toDisplayString(hikaku.newValue), 1)
                  ]))
                }), 128))
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (SiyohikakuList.value.length > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
          _hoisted_15,
          _createElementVNode("div", _hoisted_16, [
            _createElementVNode("table", null, [
              _hoisted_17,
              _createElementVNode("tbody", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(SiyohikakuList.value, (Siyohikaku) => {
                  return (_openBlock(), _createElementBlock("tr", {
                    key: Siyohikaku.key
                  }, [
                    _createElementVNode("td", null, _toDisplayString(Siyohikaku.item), 1),
                    _createElementVNode("td", null, _toDisplayString(Siyohikaku.oldValue), 1),
                    _createElementVNode("td", _hoisted_18, _toDisplayString(Siyohikaku.newValue), 1)
                  ]))
                }), 128))
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_19, [
      _createElementVNode("button", {
        onClick: _cache[0] || (_cache[0] = ($event: any) => (backtokikakuedit(newDataKikaku.value.kikakuId))),
        class: "submit_btn"
      }, " 修正 "),
      _createElementVNode("button", {
        onClick: submitData,
        class: "submit_btn"
      }, "一時保存")
    ])
  ]))
}
}

})